
import axios from 'axios'
import moment from "moment";
export function humanFileSize(bytes, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + "b";
    }

    const units = si
        ? ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
        : ["kb", "mb", "gb", "tb", "PB", "EB", "ZB", "YB"]
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
    );

    return bytes.toFixed(dp) + units[u];
}

export function timeAgo(date) {
    moment.locale('ru');
    // moment.tz('Europe/Moscow');
    return moment(date, "YYYY-MM-DD HH:mm:ss ZZ z").utc().fromNow()
}


export function setAuthToken(token) {
  axios.defaults.headers.common.Authorization = token
}
 